/**
 * Lightweight client-side JSONPath helpers for the redesigned REST source
 * previews (record counts + live filtering). Preview-only — never affects
 * serialization.
 */

export const parseMaybeJson = (value: any): any => {
  if (value == null) return undefined;
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

/** Resolve a simple JSONPath: $, $.a.b, $.a[0].b, $.a[*].b. */
export const extractAtPath = (data: any, path: string): any => {
  if (!path || path.trim() === '' || path.trim() === '$') return data;
  const cleaned = path.trim().replace(/^\$/, '').replace(/^\./, '');
  if (!cleaned) return data;
  const tokens = cleaned.match(/[^.[\]]+/g) || [];
  const walk = (node: any, i: number): any => {
    if (i >= tokens.length) return node;
    if (node == null) return undefined;
    const tok = tokens[i];
    if (tok === '*') {
      return Array.isArray(node) ? node.map((n) => walk(n, i + 1)) : undefined;
    }
    const key = /^\d+$/.test(tok) ? Number(tok) : tok;
    return walk(node[key], i + 1);
  };
  return walk(data, 0);
};

/** Record count at a path: array length, 1 for a present value, undefined if absent. */
export const recordCountAtPath = (content: any, path: string): number | undefined => {
  const value = extractAtPath(parseMaybeJson(content), path);
  if (value === undefined) return undefined;
  return Array.isArray(value) ? value.length : 1;
};
